export const kebabToPascal = (text: string) => {
  const clearAndUpper = (text: string) => text?.replace(/-/, '').toUpperCase() || text;

  return text?.replace(/(^\w|-\w)/g, clearAndUpper) || text;
};

export default kebabToPascal;
